/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Download_LinuxInputs */

const en_gc_resources_download_linux = /** @type {(inputs: Gc_Resources_Download_LinuxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linux`)
};

const zh_gc_resources_download_linux = /** @type {(inputs: Gc_Resources_Download_LinuxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linux`)
};

/**
* | output |
* | --- |
* | "Linux" |
*
* @param {Gc_Resources_Download_LinuxInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_download_linux = /** @type {((inputs?: Gc_Resources_Download_LinuxInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Download_LinuxInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_download_linux(inputs)
	return zh_gc_resources_download_linux(inputs)
});
export { gc_resources_download_linux as "gc.resources.download.linux" }